import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: new Date(),
    }
    this.getFormatDate = this.getFormatDate.bind(this);
  }
  getFormatDate(date) {
    return date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日 " + date.getHours() + "時" + date.getMinutes() + "分";
  }
  render() {
    return (
      <div>
        <DatePicker
          locale="ja"
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={15}
      timeCaption="time"
      dateFormat="MMMM d, yyyy h:mm aa"
          selected={this.state.day}
          onChange={(date) => this.setState({day: date})}
          customInput={<button>{this.getFormatDate(this.state.day)}</button>} />
      </div>
    );
  }
}

export default App;
